// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";

import App from "@/framework/App";
import router from "@/framework/router";

import { sync } from "vuex-router-sync";
try {
  var store = require("@/store/store").default;
} catch (err) {
  try {
    var store = require("@/framework/store/store").default;
  } catch (err) {}
}

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
//import "vue-material/dist/theme/default.css"; // This line here

/*
import VueHtmlToPaper from 'vue-html-to-paper';
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}
Vue.use(VueHtmlToPaper, options);
*/

try {
  require("@/lib/_autoload.js");
} catch (err) {
  require("@/framework/lib/_autoload.js");
}

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  icons: {
    clear: "remove_circle"
  }
});
Vue.use(VueMaterial);
Vue.use(require("vue-moment"));

import VueDraggable from "vue-draggable";
Vue.use(VueDraggable);

import VueParticles from "vue-particles";
Vue.use(VueParticles);

import Toasted from "vue-toasted";
Vue.use(Toasted);

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import localept from "element-ui/lib/locale/lang/pt-br";
import localeen from "element-ui/lib/locale/lang/en";
import localees from "element-ui/lib/locale/lang/es";

try {
  var crudglobal = require("@/admin/listagem/crud.vue").default;
} catch (err) {
  var crudglobal = require("@/framework/admin/listagem/crud.vue").default;
}

Vue.component("crud-tag", crudglobal);

sync(store, router);

if (global.config.socketio === true) {
  try {
    require("@/socket.io.js");
  } catch (err) {
    require("@/framework/socket.io.js");
  }
}

import moment from "moment";

Vue.mixin({
  methods: {
    T(key = "", args = [], fn = null) {
      return global.fn.meta_translate(key, args, fn, this);
    },
    perm_can_do(tela, acao) {
      return global.features.perm_can_do(tela, acao);
    },
    momentMaisUm(data) {
      if (data == null || data == "") return "";
      return moment(data).add(1, "day");
    },
    PontuacaoMilhar(x) {
      var parts = x.toString().split(",");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(",");
    }
  },
  computed: {
    $isMobile() {
      return window.innerWidth < 600;
    }
  }
});

import VueToast from "vue-toast-notification";
// Import one of available themes
import "vue-toast-notification/dist/theme-default.css";
//import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);


try {
  require("@/mainroot.js");
} catch (err) {
  try {
    require("@/framework/mainroot.js");
  } catch (err) {}
}

import "@/theme/styles/index.scss";
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>",
  beforeMount() {
    let lang =
      this.$store.state.lang ||
      (global.config.metadmin && global.config.metadmin.multilang
        ? global.config.metadmin.multilang.def
        : "pt");

    let locale = localept;
    if (lang == "pt") locale = localept;
    if (lang == "en") locale = localeen;
    if (lang == "es") locale = localees;

    Vue.use(ElementUI, {
      locale
    });
  }
});
